import React, { useCallback } from 'react';
import * as Store from '@apply/store';
import { useNavigate } from 'react-router-dom';
import { ShowIf } from '@apply/ui';

export interface PropertySubheaderProps {
    property: Store.PropertiesStore.Types.Property;
    index: number;
    apiId?: string;
    formCompleted: boolean;
    token: string;
    printMode: boolean;
}

export const formatLinkDestination = (property: Store.PropertiesStore.Types.Property, apiId?: string, token?: string): string => {
    const qp = `?pid=${property?.guid ?? ''}${token ? '&token=' + token : ''}`;
    if (apiId) {
        return `/property/${apiId}${qp}`;
    } else {
        return `/property/${qp}`;
    }
};

export const PropertySubheader: React.FC<PropertySubheaderProps> = ({
    property,
    index,
    apiId,
    formCompleted,
    token,
    printMode,
}) => {
    const navigate = useNavigate();

    const handlePress = useCallback(() => {
        navigate(formatLinkDestination(property, apiId, token));
    }, [navigate, property, apiId, token]);

    return (
        <div className='gray-background'>
            <div className='row data-row-subheader'>
                <div className='columns'>{Store.PropertiesStore.Types.formatPropertyName(index, property)}</div>
                <div
                    className='columns'
                    style={{ whiteSpace: 'pre-wrap' }}
                >
                    <ShowIf showIf={!printMode && !formCompleted}>
                        <button
                            className='button hollow move-button-left'
                            role='link'
                            aria-label='Edit'
                            onClick={handlePress}
                        >
                            <img
                                src='assets/img/edit.svg'
                                role='presentation'
                                alt=''
                            />
                            <span className='property-subheader-edit-button-text'>Edit</span>
                        </button>
                    </ShowIf>
                </div>
            </div>
        </div>
    );
};
